export const RECOMMENDATION_ACTIONS = {
  SHOW: 'show',
  CLICK: 'click',
} as const;

export type RecommendationAction = ValueOf<typeof RECOMMENDATION_ACTIONS>;
